import { useExperience } from "../../../../../../../shared/context/ExperienceContext";
import { Icons } from "../../../../../../../shared/icons/icons";
import { getBenefitsWhatsAppLink } from "../../../../../../../shared/config/contact.config";

export default function BenefitsCommitment({ content, ArrowIcon }) {
  const { mode } = useExperience();

  const whatsappHref = getBenefitsWhatsAppLink(mode);

  return (
    <div className="benefits-section__commitment reveal-on-scroll reveal-on-scroll--up reveal-delay-2">
      <div className="benefits-section__commitment-icon">
        <Icons.Leaf />
      </div>

      <div className="benefits-section__commitment-title">
        <strong>{content.commitmentTitle}</strong>
        <em>{content.commitmentAccent}</em>
      </div>

      <div className="benefits-section__commitment-divider" />

      <p>{content.commitmentText}</p>

      <a
        href={whatsappHref}
        target="_blank"
        rel="noreferrer"
        className="benefits-section__commitment-btn"
        aria-label="Agendar atendimento pelo WhatsApp"
      >
        {content.commitmentButton}

        <span>
          <ArrowIcon />
        </span>
      </a>
    </div>
  );
}